import Cookies from 'js-cookie';
import { countryCodesForMobile, storage_keys } from '@/constant/configs';
import { removeCustomerAuthToken } from '../actions/customer';
import { removeRestaurantToken } from '../actions/restaurant';

export const setRestaurantImpersonateIDs = (id: string) => {
  Cookies.set(storage_keys.res_impersonate_id, id);
  localStorage.setItem(storage_keys.res_impersonate_id, id);
};

export const removeRestaurantImpersonateIDs = () => {
  Cookies.remove(storage_keys.res_impersonate_id);
  localStorage.removeItem(storage_keys.res_impersonate_id);
};

export const isImpersonateRestaurant = (): boolean => {
  return !!localStorage.getItem(storage_keys.res_impersonate_id);
};

export const setCustomerImpersonateIDs = (id: string) => {
  Cookies.set(storage_keys.impersonate_id, id);
  localStorage.setItem(storage_keys.impersonate_id, id);
};

export const removeCustomerImpersonateIDs = () => {
  Cookies.remove(storage_keys.impersonate_id);
  localStorage.removeItem(storage_keys.impersonate_id);
};

export const isImpersonateCustomer = () => {
  return localStorage.getItem(storage_keys.impersonate_id);
};

interface EventParams {
  event: string;
  eventOptions: GtagEventParams;
}

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

interface GtagEventParams {
  [key: string]: any;
}

export const pushEvent = ({ event, eventOptions }: EventParams) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      ...eventOptions,
    });
  }
};

const CUSTOMER_AUTH_COOKIE_KEYS = [storage_keys.customer_token];
const CUSTOMER_AUTH_LOCAL_STORAGE_KEYS = [
  storage_keys.customer_token,
  storage_keys.customer_refresh_token,
  storage_keys.impersonate_id,
  storage_keys.customer_profile,
  storage_keys.firebase_device_token,
];

const RES_AUTH_COOKIE_KEYS = [storage_keys.restaurant_token];
const RES_AUTH_LOCAL_STORAGE_KEYS = [
  storage_keys.restaurant_token,
  storage_keys.restaurant_refresh_token,
  storage_keys.restaurant_profile,
  'res_user',
  storage_keys.firebase_device_token,
];

export const removeAuthCredentials = async (
  cookieKeys: string[],
  localKeys: string[]
) => {
  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers');
    const cookieStore = await cookies();
    cookieKeys.forEach((name) => {
      cookieStore.set(name, '', { maxAge: 0, path: '/' });
    });
  }

  if (typeof window !== 'undefined') {
    cookieKeys.forEach((name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    });

    localKeys.forEach((key) => {
      localStorage.removeItem(key);
    });
  }
};

export const removeCustomerAuthCreds = async () => {
  await removeCustomerAuthToken();
  await removeAuthCredentials(
    CUSTOMER_AUTH_COOKIE_KEYS,
    CUSTOMER_AUTH_LOCAL_STORAGE_KEYS
  );
};

export const removeRestaurantAuthCreds = async () => {
  await removeRestaurantToken();
  await removeAuthCredentials(
    RES_AUTH_COOKIE_KEYS,
    RES_AUTH_LOCAL_STORAGE_KEYS
  );
};

export const formatPhone = (ccode: string, phone?: string | null) => {
  if (!phone) return '';
  if (phone.startsWith('+')) return phone;
  const countryCode =
    countryCodesForMobile[ccode as keyof typeof countryCodesForMobile] || '+49';
  const numericCode = countryCode.slice(1); // Remove the '+'
  if (phone.startsWith(numericCode)) return '+' + phone;
  return countryCode + phone;
};
